// src/components/analytics/GeographicChart.js - Geographic distribution chart
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const GeographicChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500 dark:text-shayek-dark-500">
        No geographic data available
      </div>
    );
  }

  const chartData = data.map(item => ({
    country: item.country || 'Unknown',
    count: item.count || 0
  }));

  // Color palette - Shayek brand
  const COLORS = [
    '#751F19', '#8b5cf6', '#10b981', '#f59e0b', 
    '#ef4444', '#ec4899', '#06b6d4', '#84cc16'
  ];

  const isDark = document.documentElement.classList.contains('dark');
  const gridColor = isDark ? '#333333' : '#e5e7eb';
  const axisColor = isDark ? '#8A8A8A' : '#6b7280';
  const tooltipBg = isDark ? '#2A2A2A' : '#fff';
  const tooltipBorder = isDark ? '#333333' : '#e5e7eb';
  const tooltipText = isDark ? '#E0E0E0' : '#000';

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 5, right: 30, left: 140, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
        <XAxis
          type="number"
          stroke={axisColor}
          style={{ fontSize: '12px' }}
          tick={{ fill: axisColor }}
        />
        <YAxis
          type="category"
          dataKey="country"
          stroke={axisColor}
          style={{ fontSize: '11px' }}
          width={130}
          tick={{ fill: axisColor }}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: tooltipBg, 
            border: `1px solid ${tooltipBorder}`,
            borderRadius: '8px',
            padding: '8px',
            color: tooltipText
          }}
          labelStyle={{ color: tooltipText }}
        />
        <Bar dataKey="count" fill="#751F19" radius={[0, 8, 8, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GeographicChart;

